export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12865.cd89e998.jpg";